// Yup
import { object, string, number } from 'yup';

const fareSchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  value: number().required('Campo valor obrigatório'),
  keepUntil: string()
    .nullable()
    .when('validateFieldkeepUntil', {
      is: true,
      then: string()
        .nullable()
        .required('Campo obrigatório'),
    }),
  validFrom: string().when('validateFieldValidFrom', {
    is: true,
    then: string().required('Campo obrigatório'),
  }),
  description: string().required('Campo nome obrigatório'),
});

export { fareSchema };
export default fareSchema;
